/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createReducer, on } from "@ngrx/store";
import { AddFamilyInformationReturnCodes } from "../../models/family-information-model";
import { GetPdfLocationPathSuccess, GetUserCustomImageSuccess, OpenPdfFileSuccess, ValidateAndGetDataSuccess } from "./add-family-information-actions";
import { DeviceEquipmentDetailsInputData } from "../../models/device-equipment-details-return-codes";

export const AddFamilyInformationKey = 'AddFamilyInformation';

export interface AddFamilyInformationState {
  pdfLocationPath?: string;
  openPdfFile?: AddFamilyInformationReturnCodes;
  userCustomImage?: string;
  deviceEquipmentInputData?: DeviceEquipmentDetailsInputData;
}

export const addFamilyInformationStateInitialState: AddFamilyInformationState = {
  pdfLocationPath: '',
  openPdfFile: AddFamilyInformationReturnCodes.Success,
  userCustomImage: '',
  deviceEquipmentInputData: null
};

export const AddFamilyInformationReducer = createReducer(
  addFamilyInformationStateInitialState,

  on(GetPdfLocationPathSuccess, (state, action) => ({
    ...state,
    pdfLocationPath: action.response,
  })),

  on(OpenPdfFileSuccess, (state, action) => ({
    ...state,
    openPdfFile: action.response
  })),

  on(GetUserCustomImageSuccess, (state, action) => ({ 
    ...state,
    userCustomImage: action.response
  })),

  on(ValidateAndGetDataSuccess, (state, action) => ({
    ...state,
    deviceEquipmentInputData: action.response
  }))
);